import IconCheck from '@dealroadshow/uikit-icon/IconCheck';
import { useScheduleYourCallFormContext }
  from '@/evercall/application/scheduleYourCallForm/ScheduleYourCallFormContext';

import styles from './ourCommitment.module.scss';

const OurCommitment = () => {
  const { state: { isInitialized } } = useScheduleYourCallFormContext();

  if (!isInitialized) {
    return null;
  }

  return (
    <ul className={ styles.list }>
      <li className={ styles.item }><IconCheck className={ styles.icon } /> Best-in-class service & support</li>
      <li className={ styles.item }><IconCheck className={ styles.icon } /> 24x7x365 global availability</li>
      <li className={ styles.item }><IconCheck className={ styles.icon } /> Simple & transparent pricing</li>
      <li className={ styles.item }><IconCheck className={ styles.icon } /> Minimal participant wait times</li>
    </ul>
  );
};

export default OurCommitment;
